export const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../../../views/anon/Home"),
    meta: {
      title: "Give your pensions some love",
      description: "Helping you understand your pensions.",
    },
  },
  {
    path: "/integration",
    name: "ProviderIntegration",
    component: () => import("../../../views/anon/Integration"),
    meta: {
      title: "Pension Provider Integration",
      description: "Integrate your Guiide plan with our pension provider and investment management team.",
    },
  },
  {
    path: "/media",
    name: "Media",
    component: () => import("../../../views/anon/Media"),
    meta: {
      title: "Media",
      description: "Helpful videos about pensions.",
    },
  },
  {
    path: "/faq",
    name: "FAQ",
    component: () => import("../../../views/anon/FAQs"),
    meta: {
      title: "FAQs",
      description: "Frequently asked questions.",
    },
  },
  {
    path: "/ifapanel",
    name: "IFAPanel",
    component: () => import("../../../views/anon/AdviserPanel"),
    meta: {
      title: "IFA Panel",
      description: "Panel of Independent Financial Advisors.",
    },
  },
  {
    path: "/drawdowncostcomparer",
    name: "DrawdownCostComparer",
    component: () => import("../../../views/anon/LowCostDrawdown"),
    meta: {
      title: "Drawdown Cost Comparer",
      description: "Compare pension drawdown provider costs.",
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../../../views/anon/Login"),
    meta: {
      title: "Log In",
      description: "Log into your account.",
    },
  },
  {
    path: "/account/forgotpassword",
    name: "Forgot Password",
    component: () => import("../../../views/anon/ForgotPassword"),
    meta: {
      title: "Forgot Password",
      description: "Send a password reset email.",
    },
  },
  {
    path: "/account/changeforgottenpassword",
    name: "Reset Password",
    component: () => import("../../../views/anon/ResetPassword"),
    meta: {
      title: "Reset Password",
      description: "Reset your password.",
    },
  },
  {
    path: "/account/confirmemail",
    name: "Confirm Email",
    component: () => import("../../../views/anon/ConfirmAccount"),
    meta: {
      title: "Confirm Account",
      description: "Confirm your account.",
    },
  },
  {
    path: "/howtocompletedesign",
    name: "How to Complete Your Design",
    component: () => import("../../../views/anon/HowToCompleteDesign.vue"),
    meta: {
      title: "How To Complete Your Design",
      description: "Find out about how to complete a retirement plan with Guiide.",
    },
  },
  {
    path: "/account/retirementhaspassed",
    name: "RetirementHasPassed",
    component: () => import("../../../views/anon/RetirementPassed.vue"),
    meta: {
        title: "Retirement Has Passed",
        description: "Access denied. You have now retired.",
    },
  }
];
